import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ReportFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ReportFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m21.815 10-3.18-5.5c-.71-1.23-2.04-2-3.46-2h-6.35c-1.42 0-2.75.77-3.46 2L2.185 10a4.022 4.022 0 0 0 0 4l3.18 5.5c.71 1.23 2.04 2 3.46 2h6.35c1.42 0 2.75-.77 3.46-2l3.18-5.5c.71-1.23.71-2.76 0-4Zm-10.85-3.5h2v6h-2v-6Zm1 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ReportFilled;